export default __webpack_public_path__ + "static/media/grafema_amcc_04.aac8b9e6.jpg";